export { default } from './MapCreateSpotMedia';
